<template>
  <div class="school-home">
    <!-- 数据概览 -->
    <Row>
      <Col span="24">
        <cloItem
          :name="basicColumns.name"
          :title="basicColumns.title"
          :content="basicColumns.content"
        ></cloItem>
      </Col>
    </Row>
    <!-- 营收统计 -->
    <!-- <Row>
      <Col span="24">
        <cloItem
          :name="revenueColumns.name"
          :title="revenueColumns.title"
          :content="revenueColumns.content"
        ></cloItem>
      </Col>
    </Row> -->
    <!-- 考勤统计、最受欢迎TOP5 -->
    <!-- <Row :gutter="16">
      <Col span="8">
        <cloItem
          :name="top5Columns.name"
          :title="top5Columns.title"
          :content="top5Columns.content"
          style="height: 470px;"
        ></cloItem>
      </Col>
      <Col span="8">
        <cloItem
          :name="mealColumns.name"
          :title="mealColumns.title"
          :content="mealColumns.content"
          style="height: 470px;"
        ></cloItem>
      </Col>
      <Col span="8">
        <cloItem
          :name="tuoguanColumns.name"
          :title="tuoguanColumns.title"
          :content="tuoguanColumns.content"
          style="height: 470px;"
        ></cloItem>
      </Col>
    </Row> -->
    <!-- 课程概览 -->
    <!-- <Row>
      <Col span="24">
        <cloItem
          :name="courseColumns.name"
          :title="courseColumns.title"
          :content="courseColumns.content"
          style="height: 412px;"
        >
          <template #moreSlot>
            <div class="more" @click="visible = true">
              <span class="more-text">更多</span>
              <Icon type="ios-arrow-forward"></Icon>
            </div>
          </template>
        </cloItem>
      </Col>
    </Row> -->
    <!-- 更多 -->
    <!-- <tableModal
      :visible.sync="visible"
      :table-columns="courseColumns.tableModal.columns"
      :table-data="courseColumns.tableModal.rows"
    ></tableModal> -->
  </div>
</template>

<script>
import {
  basicColumns,
  revenueColumns,
  top5Columns,
  mealColumns,
  tuoguanColumns,
  courseColumns
} from './assets/data/indexData.js';
import { getAllDate, getWeekDate } from '@utils/utils';
import { mapState } from 'vuex';
import { processingData } from '@c/colItem/config.js';
import cloItem from '@c/colItem/index.vue';
import tableModal from '@c/colItem/tableModal.vue';
export default {
  name: 'SchoolHomes',
  components: {
    cloItem,
    tableModal
  },
  data() {
    return {
      visible: false,
      /* 数据概览 */
      basicColumns: { ...basicColumns },
      /* 营收统计 */
      revenueColumns: { ...revenueColumns },
      /* 最受欢迎TOP5 */
      top5Columns: { ...top5Columns },
      /* 订餐统计 */
      mealColumns: { ...mealColumns },
      /* 托管概览 */
      tuoguanColumns: { ...tuoguanColumns },
      /* 课程概览 */
      courseColumns: { ...courseColumns }
    };
  },
  computed: { ...mapState(['userInfo']) },
  mounted() {
    this.init();
  },
  destroyed() {
    this.$eventHub.$off('onFoodTime');
    this.$eventHub.$off('onTableType');
    this.$eventHub.$off('onRevenueTime');
  },
  methods: {
    init() {
      const { startDate, endDate } = getWeekDate();
      // this.getFoodData(startDate, endDate);
      this.getRevenueData(startDate, endDate);
      this.getBasicData();
      this.getTop5Data();
      this.getTuoguanData();
      this.getCourseTypeData();
      this.update();
    },

    update() {
      /* 监听营收统计日期更新 */
      this.$eventHub.$on('onRevenueTime', data => {
        const [startDate, endDate] = data;
        this.getRevenueData(startDate, endDate);
      });
      /* 监听TOP5类型更新 */
      this.$eventHub.$on('onTableType', data => {
        this.getTop5Data(data);
      });
      /* 监听订餐统计日期更新 */
      this.$eventHub.$on('onFoodTime', data => {
        const [startDate, endDate] = data;
        // this.getFoodData(startDate, endDate);
      });
    },

    /* 数据概览 */
    async getBasicData() {
      // const { status, message } = await this.$http.getOrgsBasicData({
      //   orgId: this.userInfo.orgId
      // });
      const { status, message } = await this.$http.getPortDataApi({
        orgId: this.userInfo.orgId
      });

      if (status === 200) {
        this.basicColumns.content.list.forEach(item => {
          this.$set(item, 'value', message[item.field] || 0);
        });
      }
    },

    /* 营收统计 */
    async getRevenueData(beginTime, endTime) {
      let list = [];
      const { status, message } = await this.$http.getOrgsRevenueData({
        orgId: this.userInfo.orgId,
        beginTime: `${beginTime} 00:00:00`,
        endTime: `${endTime} 00:00:00`
      });
      const dayMap = getAllDate(beginTime, endTime);
      try {
        if (status === 200) {
          const { totalAmount, returnAmount, revenues } = message;
          this.revenueColumns.content.numInfo = Object.assign(message, {
            totalAmount: this.moneyFixed(totalAmount),
            returnAmount: this.moneyFixed(returnAmount)
          });
          list = processingData(dayMap, revenues);
        }
      } finally {
        const [
          dayName,
          moneyName,
          backName
        ] = this.revenueColumns.content.chartData.columns;
        this.revenueColumns.content.chartData.rows = dayMap.map(v => {
          const row = list.find(k => k.totalDay === v) || {};
          return {
            [dayName]: v.substring(5, v.length),
            [moneyName]: this.moneyFixed(row.totalAmount || 0),
            [backName]: this.moneyFixed(row.refundAmount || 0)
          };
        });
      }
    },

    /* 最受欢迎TOP5 */
    async getTop5Data(classType = 1) {
      const { status, message } = await this.$http.getOrgsTop5Data({
        orgId: this.userInfo.orgId,
        classType // 课班类型 1-课程 2-托管
      });
      if (status === 200) {
        const typeMap = {
          1: '早托',
          2: '午托',
          3: '晚托'
        };
        const data = message.length >= 5 ? message.slice(0, 5) : message;
        this.top5Columns.content.rows = data.map(item => {
          const typeName =
            classType == 2 ? typeMap[item.classTimeType] : item.courseTypeName;
          return Object.assign(item, {
            courseTypeName: typeName || ''
          });
        });
      }
    },

    /* 订餐统计 */
    async getFoodData(beginTime, endTime) {
      const { status, message } = await this.$http.getOrgsFoodData({
        orgId: this.userInfo.orgId,
        day: `${beginTime} 00:00:00`,
        endDay: `${endTime} 00:00:00`
      });
      if (status === 200) {
        this.mealColumns.content.rows = message.schNum || [];
      }
    },

    /* 托管概览 */
    async getTuoguanData() {
      const { status, message } = await this.$http.getOrgsTuoguanData({
        orgId: this.userInfo.orgId
      });
      if (status === 200) {
        this.tuoguanColumns.content.list = this.assignment(1, message);
      }
    },

    /* 课程概览 */
    async getCourseTypeData() {
      const { status, message } = await this.$http.getOrgsCourseTypeData({
        orgId: this.userInfo.orgId
      });
      if (status === 200) {
        const data = this.assignment(2, message);
        this.courseColumns.tableModal.rows = message;
        this.courseColumns.content.list =
          data.length >= 6 ? data.slice(0, 6) : data;
      }
    },

    moneyFixed(num) {
      const newNum = !isNaN(+num) ? +num : 0;
      return newNum / 100;
    },

    assignment(type, data) {
      return data.map(v => {
        const name =
          type === 1
            ? this.tuoguanColumns.typeMap[v.classTimeType]
            : v.courseTypeName;
        const itemLabel = type === 1 ? '课班' : '开班';
        const children =
          type === 2
            ? [
              {
                label: '课程',
                value: v.courseNumber
              }
            ]
            : [];
        return {
          name: name,
          children: [
            ...children,
            {
              label: itemLabel,
              value: v.classNumber
            },
            {
              label: '报名',
              value: v.signUpNumber
            }
          ]
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.school-home {
  height: 100%;
  min-width: 1200px;
  padding: 16px;
}
</style>
